const paceStringToMinutes = (paceString) => {
    const parts = paceString.split(':');
    const min = Number(parts[0]);
    const sec = Number(parts[1]);
    const paceMinutes = (min + (sec / 60)).toFixed(2);
    return paceMinutes;
};

export default paceStringToMinutes;



/** WEBPACK FOOTER **
 ** ./src/utils/paceStringToMinutes.js
 **/